<template>
  <div class="shop_content">
    <top-ad></top-ad>
    <top-nav></top-nav>
    <!-- 店铺图片 -->
    <div class="middle_center">
      <router-link :to="{path: 'sshopIndex', query: {id: shopId}}">
        <img class="logo"
             :src="shop ? common.showPic(shop.logo) : '@/assets/images/LOGO.png'"
             :alt="shop ? shop.expectShopName:''"
             :onerror="common.defaultImg()">
      </router-link>
      <!-- 店铺情况 -->
      <div class="info">
        <Row :gutter="6">
          <Col style="font-weight: bold; font-size: 18px;">{{shop ? shop.expectShopName : '--'}}<span style="margin-left: 20px; color: red;">{{ shop.createDate | formatDuration}}</span></Col>
          <Col :span="24">
          <div class="row">
            <label>店铺评价：</label>
            <Rate disabled
                  icon="md-star"
                  v-model="shopLevel" />
          </div>
          </Col>
        </Row>
      </div>
      <!-- 搜索部分 -->
      <div class="search">
        <Row>
          <Col>
          <div class='search_info'>
            <input v-model="searchName"
                   placeholder='搜索服务' />
            <router-link :to="{path: '/searchGoods', query: {key: searchName}}"
                         class="back_black">全站搜索
            </router-link>
          </div>
          </Col>
          <Col>
          <Row class="operate"
               type="flex"
               justify="end"
               align="middle">
            <Col v-if="shop && shop.qq">
            <img src="@/assets/images/Notcollected.png">
            <span @click="linkService">联系客服</span>
            </Col>
          </Row>
          </Col>
        </Row>
      </div>
    </div>
    <!-- 菜单 -->
    <div class="menu">
      <Menu class="tabs"
            mode="horizontal"
            theme="light"
            :active-name="activeName"
            @on-select="selectMenu">
        <MenuItem name="sshopIndex">
        店铺首页
        </MenuItem>
        <MenuItem name="sshopProduct">
        服务产品
        </MenuItem>
        <MenuItem name="sshopAbout">
        关于我们
        </MenuItem>
      </Menu>
    </div>
    <router-view />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import TopAd from '@/layout/components/Header/TopAd'
import TopNav from '@/layout/components/Header/TopNav'
import { getSmchtshopDetail } from '@/api/service'

export default {
  name: 'index',
  components: {
    TopAd,
    TopNav
  },
  data() {
    return {
      shopId: null,
      shop: null,
      shopLevel: 5,
      activeName: 'sshopIndex',
      searchName: '',
    }
  },
  created() {
    this.shopId = this.$route.query.shopId
    if (this.shopId) {
      this.init()
    } else {
      this.$router.back()
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.activeName = this.$route.name
    })
  },
  filters: {
    formatDuration(value) {
      if (value) {
        let bTime = new Date(value).getTime()
        let eTime = new Date().getTime()
        let dTime = eTime - bTime
        if (dTime > 0) {
          dTime = dTime / 1000 / 60 / 60 / 24 / 365
          if (dTime >= 1) {
            return dTime.toFixed(0) + '年店'
          }
        }
      }
      return '新店'
    }
  },
  methods: {
    init() {
      getSmchtshopDetail({
        id: 1,
        mchtId: this.shopId,
        type: 2
      }).then(res => {
        this.shop = res.data
        this.shopLevel = this.shop.shopLevel || 5
      })
    },
    selectMenu(value) {
      this.$router.push({
        path: value,
        query: { shopId: this.shopId }
      })
    },
    linkService() {
      window.open('https://wpa.qq.com/msgrd?v=3&uin=' + this.shop.qq + '&site=qq&menu=yes');
    }
  },
  computed: {
    ...mapState(['userid'])
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        this.activeName = this.$route.name
      },
      // 深度观察监听
      deep: true
    }
  }
}
</script>

<style lang="less" scoped>
@import "~@/my-theme/index.less";

.shop_content {
  color: #020202;
}

.middle_center {
  padding: 20px 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin: 0 auto;
  width: 1200px;

  .search {
    flex: 1;
    max-width: 600px;
    text-align: right;
    margin: 0 auto;
  }

  .target {
    text-align: center;
    margin-top: 10px;
    color: #333333;
    font-size: 12px;
  }

  .logo {
    width: auto;
    height: 100px;
    margin-right: 30px;
    object-fit: contain;
  }

  .operate {
    margin-top: 15px;

    > div {
      margin-right: 15px;

      img {
        width: 11px;
        margin-right: 5px;
        vertical-align: baseline;
      }
    }
  }
}

.row {
  display: flex;
  flex-direction: row;
  align-items: center;
  label {
    font-size: 15px;
    margin-top: 5px;
  }
}

.search_info {
  margin-left: 50px;
  margin-right: 10px;
  display: flex;
  align-items: center;
}

.search_logo {
  background: @primary-color;
  color: #ffffff;
  width: 56px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0 4px 4px 0;
}

.back_black {
  padding: 0 5px;
  background: #333333;
  color: #ffffff;
  line-height: 32px;
  border-radius: 6px;
  margin-left: 10px;
}

.back_black:hover {
  color: #ffffff;
}

.search_info input {
  flex: 1;
  height: 32px;
  line-height: 32px;
  border: 1px solid @primary-color;
  padding: 0 10px;
  border-radius: 4px 0 0 4px;
}

.menu {
  li {
    font-size: 14px;
  }
}

.tabs {
  width: 1200px;
  margin: 0 auto;
  color: #020202;
  font-weight: 400;
  background: whitesmoke;
}
</style>
